import React, { Component } from "react";
import moment from 'moment';
import Table from "react-bootstrap/Table";
import { ORDER_AUDIT_TYPES, ORDER_AUDIT_VERBIAGE, ROUTE_LINK_LOCATION } from "../../../../constants/external-constants";
import { REQUEST_MODAL_TAB } from '../../../../utils/constant.utils';
import { comparePaths, getFirstNameFromFullName } from '../../../../utils/helpers.utils';

export class RequestDetailProcess extends Component {

    constructor(props) {
        super(props);
    }

    renderDays = (activities) => {

        if (activities === undefined || activities === null)
            return;

        return Object.values(activities).map(item => {
            return (
                <div key={"div"+ item.Key}>
                    <span className="order-process-detail-title">{moment(item.Key).format("DD MMM")}</span>
                    <Table>
                        <tbody>
                            {this.renderActivities(item.Value)}
                        </tbody>
                    </Table>
                </div>
            )
        })
    }

    renderActivities = (data) => {
        return data.map((item, index) => {
            return (
                <tr key={"row" +index+ item.AuditDate}>
                    <td>{moment(item.AuditDate).format("hh:mm A")}</td>
                    <td>
                        {this.renderActivityVerbiage(item.AuditType, (item.UserFullName))}
                    </td>
                </tr>
            )
        });
    }

    renderActivityVerbiage = (activityTypeId, updator) => {
        var variableToReplace = "name";
        var className = "updator-name";
        var keyName = Object.keys(ORDER_AUDIT_TYPES).find(key => ORDER_AUDIT_TYPES[key] === activityTypeId);
        if (ORDER_AUDIT_TYPES[keyName] != null) {
            if (activityTypeId == ORDER_AUDIT_TYPES.commentOrder) {
                var replacedWith = [updator, "commented"];
                variableToReplace = ["name", "commented"];
                className = ["updator-name", "update-commented"];
                return this.formatStringToHtml(ORDER_AUDIT_VERBIAGE.commentOrder, replacedWith, variableToReplace, className);
            } else {
                return this.formatStringToHtml(ORDER_AUDIT_VERBIAGE[keyName], [updator], [variableToReplace], [className]);
            }

        }
    }

    formatOrderStatus = (parts) => {
        var newTextValue=[]
        let shouldCapital = false;
        for (let i = 0; i < parts.length; i++) {
            if (parts[i].toLowerCase() === ORDER_AUDIT_VERBIAGE.order) {
                shouldCapital = true;
            }
    
            if (shouldCapital) {
                newTextValue.push(i);
            }
        }
        return newTextValue;
    }

    formatStringToHtml = (text, replacedWith, variableName, className) => {
        const parts = text.split(new RegExp("\\s+", "gi"));
        const capitalize = this.formatOrderStatus(parts);
        
        const path = comparePaths(this.props.history.location.pathname, ROUTE_LINK_LOCATION.orderDetailsRouteLink);
        return (
            <div>
                {
                    parts.map((part, id) => {
                        if (part.match(new RegExp("\{.*?\}", "gi"))) {
                            return replacedWith.map((value, index) => {
                                const reg = new RegExp("\\{" + (variableName[index]) + "\\}", "gi");
                                var newstringreplaced = text.replace(reg, "," + "{" + variableName[index] + "},");
                                return part.match(reg)
                                    ?
                                    <span key={"part-" + index} className={className[index]}
                                        onClick={() => className[index] === 'update-commented' && !path ?
                                            this.props.onCommentClick(REQUEST_MODAL_TAB.Comments) : 
                                            ""
                                        }
                                    > {replacedWith[index]} </span>
                                    : ""
                            });
                        } else {
                            return <span key={"part-" + id} className={capitalize.includes(id) ? "capital" : ""}> {part.replace(/\./g, '')} </span>
                        }
                    })
                }
            </div>
        );
    }
    
    

    render() {
        return (
            <div className="order-process-detail">
                {this.renderDays(this.props.activities)}
            </div>
        );
    }
}
